import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Activity from '@/components/Activity'
import Search from '@/components/SearchResult'
import Certificate from '@/components/CertificateResult'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/activity/:id',
      name: 'Activity',
      component: Activity
    },
    {
      path: '/search/:keyword',
      name: 'Search',
      component: Search
    },
    {
      path: '/search/',
      name: 'SearchWithoutKeyword',
      component: Search
    },
    {
      path: '/certificate/',
      name: 'certificate',
      component: Certificate
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js